import Icon from '@components/common/assets';
import ProgressBar from '@components/progressBar';
import { ProfileInfoType } from '@components/match/profile/types';
import Colors from '@domain/constant/colors';

import { V2RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './myProfile.module.scss';
const cx = classnames.bind(styles);

const NotCompleted = () => {
  return (
    <a
      href={`${V2RouteUrl.PROFILE}?source_page=MATCH`}
      target="_blank"
      rel="noreferrer"
      className={cx('container', 'notCompletedContainer')}
    >
      <div>
        <div className={cx('title')}>내 프로필</div>
        <div className={cx('description')}>
          기본, 선호, 학력 정보를 입력해 주세요.
          <Icon name="arrowRightLight" width={24} height={24} />
        </div>
      </div>
      <Icon name="errorLight" width={32} height={32} fill={Colors.C_ERROR} />
    </a>
  );
};

const Completed = ({
  completionRate,
  profileInfoType,
}: Pick<IMyProfileProps, 'completionRate' | 'profileInfoType'>) => {
  return (
    <a
      href={`${V2RouteUrl.PROFILE}?source_page=MATCH`}
      target="_blank"
      rel="noreferrer"
      className={cx('container', 'completedContainer')}
    >
      <div className={cx('titleContainer')}>
        <div className={cx('title')}>
          내 프로필
          <Icon name="arrowRightLight" width={24} height={24} />
        </div>
        <a className={cx('checkLight')}>
          <Icon name="checkCircleLight" width={32} height={32} fill={Colors.C_GREEN_100} />
        </a>
      </div>
      <div className={cx('complete')}>
        {completionRate}% 완성
        <ProgressBar
          key={profileInfoType}
          progress={completionRate}
          color={Colors.C_WHITE}
          fillColor={Colors.C_GREEN_150}
          height={4}
          fillHeight={4}
          className={cx('progressBar')}
          fillClassName={cx('progressBar')}
          transitionDuration="0.5s"
        />
      </div>
    </a>
  );
};

interface IMyProfileProps {
  profileRequiredCompleteYn: boolean;
  completionRate: number;
  profileInfoType: ProfileInfoType;
}

const MyProfile = ({ profileRequiredCompleteYn, completionRate, profileInfoType }: IMyProfileProps) => {
  return profileRequiredCompleteYn ? (
    <Completed completionRate={completionRate} profileInfoType={profileInfoType} />
  ) : (
    <NotCompleted />
  );
};

export default MyProfile;
